<template>
  <div v-if="selectedVehicle">
    <v-card v-if="tripReporting.length > 0">
      <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <card-image :title="`${selectedVehicle.plate}`" :onClick="SET_VIEW_HISTORY_DETAIL_STATE"/>
        <v-container>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card class="float-card elevation-2">
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>Di chuyển</div>
                        <div class="bold-text">{{distance}} Km</div>
                      </div>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>VT trung bình</div>
                        <div
                          :class="`bold-text ${isOverspeed(avgSpeed) ? `red--text`: `green--text`}`"
                        >{{avgSpeed}} Km/h</div>
                      </div>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>VT tối đa</div>
                        <div
                          :class="`bold-text ${isOverspeed(maxSpeed) ? `red--text`: `green--text`}`"
                        >{{maxSpeed}} Km/h</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex md12>
                <br>
                <div class="headline headline-button">
                  <span>Chi tiết hành trình</span>
                  <v-btn round color="primary" class="black--text" @click="exportExcel()">Xuất Excel</v-btn>
                </div>
                <br>
                <Timeline
                  :timeline-items="timelineItems"
                  :message-when-no-items="`Không có dữ liệu`"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
      </vue-perfect-scrollbar>
    </v-card>
    <div v-else>
      <v-toolbar class="elevation-0" color="transparent">
        <v-spacer></v-spacer>
        <v-btn icon @click="SET_VIEW_HISTORY_DETAIL_STATE(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <blank
        :src="`/static/icons/blank/history.png`"
        :firstLine="`Chưa có dữ liệu`"
        :secondLine="`Dữ liệu hành trình sẽ được hiển thị tại đây khi xe bắt đầu di chuyển`"
        :width="240"
      />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CardImage from '@/components/images/cardimage';
import Timeline from '@/components/Timeline/Timeline';
import Blank from '@/components/Blank';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as MapUtil from '@/utils/maputil';
import * as DateTimeUtil from '@/utils/datetime';
import * as ExcelJS from 'exceljs';

export default {
  name: 'history-detail-list',
  components: {
    VuePerfectScrollbar,
    CardImage,
    Timeline,
    Blank
  },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 160
      }
    };
  },
  computed: {
    ...mapGetters(['selectedVehicle', 'tripReporting', 'historyFromDate', 'historyToDate']),
    historyWaypoints () {
      let trips = [];
      if (this.tripReporting.length > 0) {
        this.tripReporting.map(a => {
          trips = trips.concat(a.points);
          return 0;
        });
      }
      return trips;
    },
    distance () {
      let total = 0;
      this.tripReporting.map(a => {
        total += a.km;
        return 0;
      });
      return total > 0 ? total.toFixed(2) : 0;
    },
    avgSpeed () {
      let totalSpeed = 0;
      this.historyWaypoints.map(a => {
        totalSpeed += a.kmh;
        return 0;
      });
      return totalSpeed > 0
        ? (totalSpeed / this.historyWaypoints.length).toFixed(2)
        : 0;
    },
    maxSpeed () {
      let maxSpeed = 0;
      this.historyWaypoints.map(a => {
        maxSpeed = a.kmh > maxSpeed ? a.kmh : maxSpeed;
        return 0;
      });
      return maxSpeed;
    },
    timelineItems () {
      let timeline = [
        {
          items: []
        }
      ];

      this.tripReporting.map((trip, index) => {
        let startPoint = trip.points[0];
        let endPoint = trip.points[trip.points.length - 1];

        // Add start item
        if (index === 0) {
          let startItem = {
            time: DateTimeUtil.formatSecondToHHmm(startPoint.time),
            color: 'orange'
          };
          startItem.title = 'Bắt đầu';
          startItem.description = MapUtil.getAddressFromWaypoint(startPoint);
          timeline[0].items.push(startItem);
        }

        // Add moving item
        let movingItem = {
          time: DateTimeUtil.formatSecondToHHmm(startPoint.time),
          color: 'green'
        };

        let totalDistance = (endPoint.kmage - startPoint.kmage).toFixed(2);
        let totalTime = DateTimeUtil.formatSecondToDuration(
          endPoint.time - startPoint.time
        );

        let totalSpeed = 0;
        let maxSpeed = 0;
        let count = 0;

        trip.points.map(point => {
          totalSpeed += point.kmh;
          maxSpeed = point.kmh > maxSpeed ? point.kmh : maxSpeed;
          count++;
          return 0;
        });

        let avgSpeed = (totalSpeed / count).toFixed(2);

        movingItem.title = `Di chuyển ${totalDistance} km trong ${totalTime}`;
        movingItem.description = `Vận tốc TB: ${avgSpeed} km/h, tối đa: ${maxSpeed} km/h`;
        timeline[0].items.push(movingItem);

        // Add stopped item
        let stoppedItem = {
          time: DateTimeUtil.formatSecondToHHmm(endPoint.time),
          color: 'orange'
        };
        let duration = DateTimeUtil.formatSecondToDuration(
          trip.nextTripStart.time - endPoint.time
        );
        stoppedItem.description = MapUtil.getAddressFromWaypoint(endPoint);

        if (index < this.tripReporting.length - 1) {
          stoppedItem.title = `Dừng ${duration}`;
        } else {
          stoppedItem.title = `Kết thúc`;
        }

        timeline[0].items.push(stoppedItem);

        return 0;
      });

      return timeline;
    }
  },
  methods: {
    ...mapMutations(['SET_VIEW_HISTORY_DETAIL_STATE']),
    isOverspeed (speed) {
      return speed > (this.selectedVehicle.maxSpeed || 999);
    },
    exportExcel () {
      if (this.tripReporting.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      const topHeader = `Báo Cáo Hành Trình Chi Tiết\nTừ ${DateTimeUtil.formatDateTime(this.historyFromDate)} Đến ${DateTimeUtil.formatDateTime(this.historyToDate)}\nXe ${this.selectedVehicle.plate}`;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet 1');

      let data = [];
      // eslint-disable-next-line array-callback-return
      this.tripReporting.map((trip, index) => {
        const next = {
          '#': 'Bắt đầu',
          'Quãng đường (Km)': trip.nextTripStart.kmage,
          'Vận tốc (Km/h)': trip.nextTripStart.kmh,
          'X (lng)': trip.nextTripStart.x / 1e6,
          'Y (lat)': trip.nextTripStart.y / 1e6,
          'Thời gian': DateTimeUtil.formatSecondToYYMMDDHHmm(trip.nextTripStart.time),
          'Địa chỉ': `${trip.nextTripStart.data.addr ? trip.nextTripStart.data.addr + ', ' : ''}${trip.nextTripStart.data.admin || ''}`,
          utc: trip.nextTripStart.utcTicks,
        };
        data.push(next);

        const prev = {
          '#': index === 0 ? 'Bắt đầu' : 'Dừng',
          'Quãng đường (Km)': trip.prevTripEnd.kmage,
          'Vận tốc (Km/h)': trip.prevTripEnd.kmh,
          'X (lng)': trip.prevTripEnd.x / 1e6,
          'Y (lat)': trip.prevTripEnd.y / 1e6,
          'Thời gian': DateTimeUtil.formatSecondToYYMMDDHHmm(trip.prevTripEnd.time),
          'Địa chỉ': `${trip.prevTripEnd.data.addr ? trip.prevTripEnd.data.addr + ', ' : ''}${trip.prevTripEnd.data.admin || ''}`,
          utc: trip.prevTripEnd.utcTicks,
        };
        data.push(prev);

        if (trip.points) {
          trip.points.forEach((waypoint, index) => {
            const point = {
              '#': index,
              'Quãng đường (Km)': waypoint.kmage,
              'Vận tốc (Km/h)': waypoint.kmh,
              'X (lng)': waypoint.x / 1e6,
              'Y (lat)': waypoint.y / 1e6,
              'Thời gian': DateTimeUtil.formatSecondToYYMMDDHHmm(waypoint.time),
              'Địa chỉ': `${waypoint.data.addr ? waypoint.data.addr + ', ' : ''}${waypoint.data.admin || ''}`,
              utc: waypoint.utcTicks,
            };
            data.push(point);
          });
        }
      });

      data.sort((a, b) => (a.utc < b.utc ? -1 : 1));
      data[data.length - 1]['#'] = 'Kết thúc';

      const headers = Object.keys(data[0]).filter(key => key !== 'utc');
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' }};
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '808080' },
        };
      });

      worksheet.spliceRows(1, 0, [topHeader]);
      worksheet.mergeCells(1, 1, 1, headers.length);

      const topRow = worksheet.getRow(1);
      topRow.font = { bold: true };
      topRow.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      topRow.height = 60;

      headers.forEach((header, columnIndex) => {
        let maxLength = header.length;
        data.forEach((item) => {
          const cellValue = String(item[header]);
          const cellLength = cellValue.length;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        worksheet.getColumn(columnIndex + 1).width = maxLength + 2;
      });

      data.forEach((item) => {
        const row = [];
        headers.forEach((header) => {
          row.push(item[header]);
        });
        const excelRow = worksheet.addRow(row);
        if (item['#'] === 'Bắt đầu' || item['#'] === 'Dừng' || item['#'] === 'Kết thúc') {
          excelRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'fff3cd' },
            };
          });
        }
      });

      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${this.selectedVehicle.plate}_${DateTimeUtil.formatExportDate(this.historyFromDate)}_${DateTimeUtil.formatExportDate(this.historyToDate)}_${DateTimeUtil.formatExportDate(new Date())}`;
        link.click();
      });
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 64px);
  overflow: auto;
}
.float-card {
  margin-top: 56px;
  padding: 8px;
}
.bold-text {
  font-weight: bold;
  font-size: 14pt;
}
.headline-button{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/components/historydetail.vue